import { render } from "./Staff.vue?vue&type=template&id=43b01862&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=43b01862&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-43b01862"

export default script